import { useQuery } from 'convex/react';

import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { useAuth } from './useAuth';

/**
 * Reactive single-project read. Returns `undefined` while loading,
 * `null` if the project does not exist or the user does not own it,
 * or the project document otherwise.
 *
 * Used by the wizard, pipeline, and delivery pages.
 */
export function useProject(projectId: Id<'projects'> | null) {
  const { token } = useAuth();
  const skip = !token || !projectId;

  return useQuery(api.projects.get, skip ? 'skip' : { token: token!, projectId: projectId! });
}
